@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../../products/product-details/style.module.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../../constants/spacing.module.less';

.plan-feature {
  margin-bottom: @space-16;

  &:last-of-type {
    min-height: 90px;
    margin-bottom: @space-8;
  }
}

.plan-row {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.your-carriers-description {
  color: @grey-600;
}

.toggle-container {
  display: flex;
  align-items: center;
  height: 100%;
}

.deactivation-message {
  margin-top: @space-8;
  border: 1px solid var(--blue-400);
}

.deactivation-message-no-carriers {
  margin: @space-16 0 0 @space-36;
  border: 1px solid var(--blue-400);
  width: 637px;
}

.byoa-loss-details {
  width: 637px;
  margin: @space-16 0 0 @space-36;
  padding: @space-8 @space-16 @space-16;
  border: 1px solid var(--grey-300);
  background: var(--grey-100);
}

.carriers-section {
  margin: @space-16 0;
  border-radius: 8px;
  max-height: 209px;
  overflow-y: auto;
}

.provider-row {
  display: flex;
  height: 48px;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
}

.provider-logo {
  width: 28px;
  height: 28px;
  margin-right: 10px;
}

.name-container {
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: var(--default--text-color--15);
}

.provider-name {
  color: var(--default--text-color--16);
}

.your-carriers-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
.your-carriers-price {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: @space-16;
}
